import React, { useState } from 'react';
import MecaPage from '../MecaPage';
import DemandForecastPage from '../DemandForecastPage';
import SalesActivityReport from './SalesActivityReport';
import TargetVsActualsReport from './TargetVsActualsReport';
import ConversionFunnelReport from './ConversionFunnelReport';

const TABS = [
  { id: 'meca', name: 'MECA Report', component: MecaPage },
  { id: 'demand-forecast', name: 'Demand Forecast', component: DemandForecastPage },
  { id: 'sales-activity', name: 'Sales Activity', component: SalesActivityReport },
  { id: 'target-vs-actuals', name: 'Target vs Actuals', component: TargetVsActualsReport },
  { id: 'conversion-funnel', name: 'Conversion Funnel', component: ConversionFunnelReport },
];

const ReportsPage = () => {
  const [activeTab, setActiveTab] = useState('meca');

  const ActiveComponent = TABS.find((tab) => tab.id === activeTab)?.component;

  return (
    <div className="h-full flex flex-col">
      <div className="bg-white border-b border-gray-200">
        <nav className="-mb-px flex space-x-8 px-6 overflow-x-auto">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${
                activeTab === tab.id
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>

      <div className="flex-1 overflow-auto">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default ReportsPage;
